'use client';
import React, { useRef } from 'react';
import type { Climb } from '@/lib/climbData';

const difficultyDot: Record<string, string> = {
  medium: 'bg-yellow-400',
  hard: 'bg-orange-400',
  extreme: 'bg-red-400',
};

interface ClimbTabsProps {
  climbs: Climb[];
  activeClimbId: string;
  onSelect: (id: string) => void;
}

export default function ClimbTabs({ climbs, activeClimbId, onSelect }: ClimbTabsProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <div className="relative mb-6">
      <div
        ref={scrollRef}
        className="flex gap-2 overflow-x-auto pb-2 scrollbar-thin"
        style={{ scrollbarWidth: 'none' }}
      >
        {climbs.map((climb) => {
          const isActive = climb.id === activeClimbId;
          return (
            <button
              key={`tab-${climb.id}`}
              onClick={() => onSelect(climb.id)}
              className={`flex-shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-all duration-150 border ${
                isActive
                  ? 'tab-active border-primary' :'tab-inactive border-border hover:border-muted-foreground'
              }`}
            >
              <span className={`w-2 h-2 rounded-full ${difficultyDot[climb.difficulty]}`} />
              <span className="whitespace-nowrap">{climb.name}</span>
            </button>
          );
        })}
      </div>
      {/* fade right */}
      <div className="absolute right-0 top-0 bottom-2 w-8 bg-gradient-to-l from-background to-transparent pointer-events-none" />
    </div>
  );
}